const arrowHugeSVG = `
<svg width="400px" height="69px" viewBox="0 0 400 69" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>arrowHuge</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <linearGradient x1="0%" y1="50%" x2="64.406296%" y2="50%" id="linearGradient-huge">
            <stop stop-color="#DADADA" stop-opacity="0" offset="0%"></stop>
            <stop stop-color="#6DC6B0" offset="100%"></stop>
        </linearGradient>
    </defs>
    <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-450.000000, -916.000000)">
        <polygon id="arrowHuge" fill="url(#linearGradient-huge)" points="450 916 824.158338 916 850 950.5 824.158338 985 450 985"></polygon>
    </g>
</svg>
`;

export default arrowHugeSVG;




// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/arrowHugeSVG.js